import React, { useState, useEffect } from 'react';
import { fetchDashboardData, generateProPayURL } from '../../services/api';
import './Launch.css';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import { Header } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';

function Launch() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loadingLinks, setLoadingLinks] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    document.title = 'Pay Loan | MAX Credit Union';
  }, []);

  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsCollapsed(true);
    } else {
      setIsCollapsed(false);
    }
  };

  useEffect(() => {
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jsonData = await fetchDashboardData();
        setData(jsonData);
      } catch (error) {
        setError(error.message);
      }
    };
    
    fetchData();
  }, []);

  const handlePayClick = async (loan) => {
    try {
      setLoadingLinks(prev => ({ ...prev, [loan.loan_id]: true }));
      
      const payLink = await generateProPayURL({
        ...loan,
        memreflink: data.memreflink,
        account_number: data.account_number,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        taxid: data.taxid
      });
      
      if (payLink === "ERROR") {
        alert("Unable to generate payment link. Please try again later or contact support.");
      } else if (!payLink) {
        alert("No payment link was received. Please try again later or contact support.");
      } else {
        window.open(payLink, '_blank');
      }
    } catch (error) {
      alert("An error occurred while processing your payment request. Please try again later or contact support.");
    } finally {
      setLoadingLinks(prev => ({ ...prev, [loan.loan_id]: false }));
    }
  };

  const contentStyle = {
    marginLeft: '250px',
    padding: '20px',
    '@media (max-width: 768px)': {
      marginLeft: '0',
      padding: '10px'
    }
  };

  if (error) {
    return (
      <>
        <Header name="Pay Loan" />
        <SideMenu menuItems={menuItems} />
        {isCollapsed && <TopMenu />}
        <div className="content-wrapper">
          <h2>Oops!</h2>
          <p>We are encountering an error with the service at this time. <br />
          You can also pay your loan via Funds Transfer or to use a card from another institution, use{' '}
          <a href="https://maxcu.lenderpayments.com/" target="_blank" rel="noopener noreferrer" title="Pay My Loan">
            Pay My Loan
          </a>.</p>
        </div>
      </>
    );
  }

  if (!data) {
    return <div>Loading...</div>;
  }
  
  if (data.status === "DOWN") {
    return (
      <>
        <Header name="Pay Loan" />
        <SideMenu menuItems={menuItems} />
        {isCollapsed && <TopMenu />}
        <div className="content-wrapper">
          <h2>Oops!</h2>
          <p>This service is currently down for maintenance. <br />
          You can also pay your loan via Funds Transfer or to use a card from another institution, use{' '}
          <a href="https://maxcu.lenderpayments.com/" target="_blank" rel="noopener noreferrer" title="Pay My Loan">
            Pay My Loan
          </a>.</p>
        </div>
      </>
    );
  }

  if (data.status === "INVALID") {
    return (
      <>
        <Header name="Pay Loan" className="custom-header-text" />
        <SideMenu menuItems={menuItems} />
        {isCollapsed && <TopMenu />}
        <div className="content-wrapper">
          <h2>Oops!</h2>
          <p>Something on your account is preventing you from using this shortcut. <br />
          You can still pay your loan using a debit card from another institution, use{' '}
          <a href="https://maxcu.lenderpayments.com/" target="_blank" rel="noopener noreferrer" title="Pay My Loan">
            Pay My Loan
          </a> and follow the prompts to setup your payment.<br /><br />
          If you want to pay your loan using your MAX checking or savings account, go to Funds Transfer to make your payment quickly and easily.</p>
        </div>
      </>
    );
  }

  if (data.status === "NOLOANS") {
    return (
      <>
        <Header name="Pay Loan" />
        <SideMenu menuItems={menuItems} />
        {isCollapsed && <TopMenu />}
        <div className="content-wrapper">
          <h2>No Qualifying Loans!</h2>
          <p>We could not find any qualifying loans for this service under your account.</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Header name="Pay Loan" />
      <SideMenu menuItems={menuItems} />
      {isCollapsed && <TopMenu />}
      <div className="content-wrapper">
        <div className="q2-row">
          <h1 className="page-title">Pay Loan</h1>
        </div>
        <div className="q2-row">
          <p>Now you can pay your MAX loan with a Debit card from another institution!</p>
        </div>

        <div className="q2-row">
          <table className="loans-table">
            <tbody>
              {data.loans && data.loans.map((loan) => (
                <tr key={loan.loan_id}>
                  <td>{loan.loan_id} - {loan.loan_description}</td>
                  <td>
                    <button 
                      onClick={() => handlePayClick(loan)}
                      className="pay-button"
                      disabled={loadingLinks[loan.loan_id]}
                    >
                      {loadingLinks[loan.loan_id] ? 'Generating...' : 'Pay Now'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Launch;
